import { render, staticRenderFns } from "./SysGatewayRouteList.vue?vue&type=template&id=5b770534&scoped=true&"
import script from "./SysGatewayRouteList.vue?vue&type=script&lang=js&"
export * from "./SysGatewayRouteList.vue?vue&type=script&lang=js&"
import style0 from "./SysGatewayRouteList.vue?vue&type=style&index=0&id=5b770534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b770534",
  null
  
)

export default component.exports